export default "__VITE_ASSET__Bjhyc6HA__"